import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#ff6467',        // Using your coral pink
          secondary: '#FBFAFB',      // From main.scss
          success: '#61C811',        // systemgreen from main.scss
          error: '#F56761',          // systemred-500 from main.scss
          warning: '#F78D88',        // systemred-400 from main.scss
          info: '#667bde',           // systemred-200 from main.scss
          surface: '#F5F5F5',        // systemblue-cool-100 from main.scss
          'surface-variant': '#D9D8DA', // systemblue-cool-200
        },
      },
      dark: {
        colors: {
          primary: '#ff6467',
          secondary: '#403E48',      // systemblue-cool-600 from main.scss
          success: '#61C811',
          error: '#F56761',
          warning: '#F78D88',
          info: '#667bde',
        },
      },
    },
  },
})
